import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { Errors } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
// Class: GameInput
var GameInput = /** @class */ (function (_super) {
    __extends(GameInput, _super);
    function GameInput() {
        return _super.call(this, undefined) || this;
    }
    Object.defineProperty(GameInput, "numDevices", {
        // JS -> AS Bindings
        // AS -> JS Bindings
        // static _numDevices: number /*int*/;
        // static _isSupported: boolean;
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInput', 'static get numDevices', '');
            return 0;
            // return this._numDevices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameInput, "isSupported", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/ui/GameInput', 'static get isSupported', '');
            return false;
        },
        enumerable: false,
        configurable: true
    });
    GameInput.getDeviceAt = function (index /*int*/) {
        index = index | 0;
        // @todo
        Debug.throwPIR('playerglobals/ui/GameInput', 'static getDeviceAt', '');
        this.sec.throwError('RangeError', Errors.ParamRangeError, 'index');
        return null;
    };
    // Called whenever the class is initialized.
    GameInput.classInitializer = null;
    // List of static symbols to link.
    GameInput.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInput.instanceSymbols = null; // [];
    return GameInput;
}(EventDispatcher));
export { GameInput };
